import * as React from 'react';
import { useSelector } from 'react-redux';

import { OfferFactItem, OfferFactsInSidebar } from '../../components/OfferFactsInSidebar';
import { selectSidebarData } from '../../selectors';

export const OfferFactsInSidebarContainer: React.FC = () => {
  const factsList = useSelector(selectSidebarData);

  if (!factsList || !factsList.length) {
    return null;
  }

  return (
    <OfferFactsInSidebar>
      {factsList.map(fact => (
        <OfferFactItem key={fact.title} {...fact} />
      ))}
    </OfferFactsInSidebar>
  );
};
